/* eslint-disable import/first,no-func-assign */
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

var SvgPodcastMicrophoneOutline = props => /*#__PURE__*/React.createElement("svg", _extends({}, props, {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 17",
  "aria-hidden": !props['aria-label'],
  focusable: "false"
}), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#podcast-microphone-outline_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M8 12.25c-1.793 0-3.25-1.474-3.25-3.287V4.037C4.75 2.224 6.207.75 8 .75s3.25 1.474 3.25 3.287v4.926c0 1.813-1.457 3.287-3.25 3.287ZM8 1.756c-1.243 0-2.255 1.023-2.255 2.28v4.927c0 1.258 1.012 2.281 2.255 2.281 1.243 0 2.255-1.023 2.255-2.28V4.036c0-1.258-1.012-2.281-2.255-2.281ZM8.5 13.5h-1v2.798h1V13.5Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.5 15.5h-5v1h5v-1ZM8 14a4.756 4.756 0 0 1-4.75-4.75h.973A3.78 3.78 0 0 0 8 13.027a3.78 3.78 0 0 0 3.777-3.777h.973A4.756 4.756 0 0 1 8 14Zm3-8.5H8v1h3v-1Zm0 2.25H8v1h3v-1Z"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "podcast-microphone-outline_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 .5h16v16H0z"
}))));

export default SvgPodcastMicrophoneOutline;